/*
 * @Descripttion : 订单
 * @version      : 
 * @Author       : karl
 * @Date         : 2021-09-07 17:52:14
 * @LastEditors  : 
 * @LastEditTime : 
 */
import request from "@/request/request";

/**
 * 获取车辆订单确认成交书 
 */
export function DealConfirmGetDetail(params) {
    return request({
        url: "api/Deal/DealConfirmGetDetail",
        method: "post",
        data: params
    });
}

/**
 * 确认成交操作 
 */
 export function DealConfirmCreate(params) {
    return request({
        url: "api/Deal/DealConfirmCreate",
        method: "post",
        data: params
    });
}
